import * as THREE from "three";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { ThreeMFLoader } from "three/examples/jsm/loaders/3MFLoader";
import { analyzeObject, autoOrient, objectIntegrity, meshIntegrity, parse3MFManual, greenMat } from "@/pages/public/Calculator";

// Render a small offscreen thumbnail of a parsed 3D object (for quotation previews).
function renderThumb(content) {
  try {
    const renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
    renderer.setSize(160, 160);
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xf1f5f9);
    scene.add(new THREE.AmbientLight(0xffffff, 0.9));
    const dl = new THREE.DirectionalLight(0xffffff, 1.4);
    dl.position.set(3, 5, 4);
    scene.add(dl);
    scene.add(content);
    const box = new THREE.Box3().setFromObject(content);
    const size = new THREE.Vector3(); box.getSize(size);
    const center = new THREE.Vector3(); box.getCenter(center);
    const d = (Math.max(size.x, size.y, size.z) || 1) * 1.9;
    const cam = new THREE.PerspectiveCamera(45, 1, d / 100, d * 10);
    cam.position.set(center.x + d, center.y + d * 0.75, center.z + d);
    cam.lookAt(center);
    renderer.render(scene, cam);
    const url = renderer.domElement.toDataURL("image/png");
    renderer.dispose();
    scene.remove(content);
    return url;
  } catch { return null; }
}

// Parse an STL/OBJ/3MF file in-browser and return geometry spec for pricing.
export function parse3DFile(file) {
  return new Promise((resolve, reject) => {
    const ext = file.name.split(".").pop().toLowerCase();
    if (!["stl", "obj", "3mf"].includes(ext)) { resolve(null); return; }
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        let content, integ = null;
        if (ext === "stl") {
          const geom = new STLLoader().parse(ev.target.result);
          if (!geom?.attributes?.position) throw new Error("geometry kosong");
          integ = meshIntegrity(geom);
          content = new THREE.Mesh(geom, greenMat());
        } else if (ext === "obj") {
          content = new OBJLoader().parse(ev.target.result);
        } else {
          try { content = new ThreeMFLoader().parse(ev.target.result); }
          catch { content = parse3MFManual(ev.target.result); }
          let any = false; content.traverse((c) => { if (c.isMesh) any = true; });
          if (!any) content = parse3MFManual(ev.target.result);
        }
        if (!integ) integ = objectIntegrity(content);
        autoOrient(content);
        const info = analyzeObject(content);
        if (info.triangles <= 0) throw new Error("Tidak ada geometri valid");
        resolve({ volume_cm3: info.volume_cm3, surface_cm2: info.surface_cm2, bbox: info.bbox, triangles: info.triangles, integ, thumb: renderThumb(content) });
      } catch (err) { reject(err); }
    };
    reader.onerror = () => reject(new Error("read error"));
    if (ext === "stl" || ext === "3mf") reader.readAsArrayBuffer(file); else reader.readAsText(file);
  });
}
